import { Partner } from '@shared/api';
import { AuthUser } from '@shared/types';

const IPP_USER = 'ippUser';
const PARTNERS = 'partners';
const SELECTED_PARTNER_ID = 'selectedPartnerId';

export class LocalStorageUtils {
  static getIppUser = (): AuthUser | undefined => {
    const ippUser = localStorage.getItem(IPP_USER);
    return ippUser ? JSON.parse(ippUser) : undefined;
  };
  static setIppUser = (ippUser?: AuthUser) => localStorage.setItem(IPP_USER, JSON.stringify(ippUser));
  static removeIppUser = () => localStorage.removeItem(IPP_USER);

  static getPartners = (): { id: number; name: string }[] | null => {
    const partners = localStorage.getItem(PARTNERS);
    return partners ? JSON.parse(partners) : null;
  };
  static setPartners = (partners: Partner[]) => localStorage.setItem(PARTNERS, JSON.stringify(partners));
  static removePartners = () => localStorage.removeItem(PARTNERS);

  static getSelectedPartnerId = (): number | null => {
    const selectedPartnerId = localStorage.getItem(SELECTED_PARTNER_ID);
    return selectedPartnerId ? JSON.parse(selectedPartnerId) : null;
  };
  static setSelectedPartnerId = (selectedPartnerId: number) => localStorage.setItem(SELECTED_PARTNER_ID, JSON.stringify(selectedPartnerId));
  static removeSelectedPartnerId = () => localStorage.removeItem(SELECTED_PARTNER_ID);
}
